import type { Theme } from '../../theme/theme-store';
import type { MapMode } from '../types';

/**
 * The color mode for map icons, from the basemap they sit on rather than the app theme. Satellite
 * imagery is dark, so it gets the dark mode colors.
 */
export function getMapIconColorMode(mapMode: MapMode): Theme {
    return mapMode === 'LIGHT_MODE' || mapMode === 'LIGHT_HUMAN_MODE' ? 'light' : 'dark';
}
